/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      // console.log('Cart ———————————— ↓');
      // console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    // console.log('theme:cart:init');
    // console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // ==========================================
  // Custom Cart Back Logic (Strict Whitelist + Robust Override - v10)
  // ==========================================
  (function() {
    try {
      console.log("Custom Cart Logic Loaded v10");
      
      var LAST_PAGE_KEY = 'last_visited_page';
      var routes = window.theme && window.theme.routes ? window.theme.routes : { root_url: '/' };
      var ROOT_URL = routes.root_url || '/';
      var ALL_PRODUCTS_URL = (routes.all_products_collection_url) ? routes.all_products_collection_url : '/collections/all';

      // 1. Determine if current page is "Cart-like"
      var currentUrl = window.location.href;
      var isCart = false;
      
      if (currentUrl.indexOf('/cart') !== -1 || 
          currentUrl.indexOf('/checkout') !== -1 || 
          currentUrl.indexOf('/account') !== -1 ||
          currentUrl.indexOf('/orders') !== -1) {
          isCart = true;
      }

      // 2. Logic
      if (!isCart) {
        // We are on a browsing page. SAVE IT.
        try {
          sessionStorage.setItem(LAST_PAGE_KEY, currentUrl);
        } catch (e) { console.warn(e); }
      } else {
        // We are on a Cart page. READ IT.
        
        var targetUrl = ALL_PRODUCTS_URL; // Default
        
        try {
          var stored = sessionStorage.getItem(LAST_PAGE_KEY);
          // Only trust stored URL if it is NOT a cart URL
          if (stored && stored.indexOf('/cart') === -1 && stored.indexOf('/checkout') === -1) {
             targetUrl = stored;
          } else if (document.referrer && document.referrer.indexOf('/cart') === -1 && document.referrer.indexOf(window.location.host) !== -1) {
             // Fallback to referrer if safe
             targetUrl = document.referrer;
          }
        } catch(e) {}
        
        // Final Safety Check
        if (targetUrl.indexOf('/cart') !== -1) {
           targetUrl = ALL_PRODUCTS_URL;
        }

        // 3. Update Links
        function fixLinks() {
           var selectors = [
             '.cart__circle__wrapper', // Empty cart icon
             '.cart__return',          // "Continue Browsing" text
             '.cart__continue__link',  // Other links
             '[data-continue-shopping]'
           ];
           
           // We select fresh every time because of potential AJAX updates
           var links = document.querySelectorAll(selectors.join(', '));
           
           for (var i = 0; i < links.length; i++) {
             var link = links[i];
             
             // Check if already processed to avoid infinite loops
             if (link.dataset.cartFixed === 'true' && link.href === targetUrl) continue;

             // Remove inline onclick if present (crucial step)
             link.removeAttribute('onclick');
             
             // Clone the node to strip all event listeners (jQuery, etc)
             var newLink = link.cloneNode(true);
             
             // Set new properties
             newLink.href = targetUrl;
             newLink.dataset.cartFixed = 'true'; // Mark as processed
             
             // Add our own robust click handler
             newLink.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                window.location.href = targetUrl;
             });

             // Replace the old node with the new one
             link.parentNode.replaceChild(newLink, link);
           }
        }

        // Run immediately
        fixLinks();
        
        // Run on load
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', fixLinks);
        }
        
        // Use MutationObserver to catch dynamic cart updates (AJAX)
        var observer = new MutationObserver(function(mutations) {
           fixLinks();
        });
        
        observer.observe(document.body, {
           childList: true,
           subtree: true
        });
        
        // Fallback interval just in case
        setInterval(fixLinks, 1000);
      }

    } catch(e) {
      console.error("Custom Script Error:", e);
    }
  })();

})();
